import { PublicClientApplication, type Configuration, LogLevel } from '@azure/msal-browser';

const CLIENT_ID = '0d8d243c-6868-4204-a00e-e6fe843f16bc';
const TENANT_ID = 'bfda869c-6c3c-49f6-8fd2-d8fe4c371508';

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
};

export const msalInstance = new PublicClientApplication(msalConfig);
